<span class="relative z-5">
  <img
    alt="Limehome"
    width="160"
    height="33.1"
    [ngSrc]="imgixHost + '/website/svg/refresh/limehome-logo.svg?auto=format'"
  />
</span>
